import React, {type JSX, type PropsWithChildren, useCallback } from 'react'

import BlockPreContent from '@components/atoms/BlockPreContent'
import Box from '@components/atoms/Box'
import { BoxBackgrounds } from '@components/atoms/Box/Box'
import Col from '@components/atoms/Grid/Col'
import Row from '@components/atoms/Grid/Row'
import { FormRevocation } from '@components/molecules/Forms/FormRevocation'

import { PropsWithClassName } from '@helper/PropsWithClassName'
import { editable } from '@helper/storyblokEditable'

import { Root } from './StoryblokRevocationForm.styles'

export type RevocationForm = {
  headline?: string
  subline?: string
  component: 'revocation-form'
  _uid: string
  [k: string]: unknown
}

type Props = PropsWithClassName & {
  blok: RevocationForm
}

const StoryblokRevocationForm: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): JSX.Element => {
  const { blok } = props
  const { headline, subline } = blok

  const onSubmit = useCallback(async (_data: object) => {}, [])

  return (
    <Root
      {...editable(blok)}
      className={props.className}
      data-testid="storyblok-revocation-form-root"
      aria-label={blok.headline?.toString()}
      title={blok.headline?.toString()}
    >
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <BlockPreContent headline={headline} subline={subline} />
        </Col>
        <Col xs={12} sm={12} md={10} mdOffset={1} lg={10} lgOffset={1}>
          <Box background={BoxBackgrounds.WHITE}>
            <FormRevocation formId="revocation" handleSubmitForm={onSubmit} />
          </Box>
        </Col>
      </Row>
    </Root>
  )
}

export { StoryblokRevocationForm }
